import {Dialog} from 'quasar';
import type {DialogChainObject} from 'quasar';
import type {VueComponent} from '../types';

type TDialogProps = Record<string, unknown>;


/* eslint-disable accessor-pairs */
/**
 * provides a way to register and use styled dialogs within theme-agnostic services
 */
class TPDialog {
	private _errorDialogComponent!: VueComponent;
	private _networkErrorDialogComponent!: VueComponent;


	public set errorDialogComponent(dialogComponent: VueComponent) {
		this._errorDialogComponent = dialogComponent;
	}

	public getErrorDialog(dialogProps?: TDialogProps) {
		if(typeof this._errorDialogComponent === 'undefined') {
			return Dialog.create({
				title: 'Error',
				...dialogProps,
			});
		}


		return Dialog.create({
			component: this._errorDialogComponent,
			...dialogProps,
		});
	}


	public set networkErrorDialogComponent(dialogComponent: VueComponent) {
		this._networkErrorDialogComponent = dialogComponent;
	}

	public getNetworkErrorDialog(dialogProps?: TDialogProps): DialogChainObject {
		if(typeof this._networkErrorDialogComponent === 'undefined') {
			return Dialog.create({
				title: 'We\'re sorry!',
				message: 'There seems to be a connection error. Please try again later.',
				ok: 'Okay, got it!',
				...dialogProps,
			});
		}

		return Dialog.create({
			component: this._networkErrorDialogComponent,
			...dialogProps,
		});
	}
}

export const DialogService = new TPDialog();
